module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "section-link"
  }, [_c('a', {
    attrs: {
      "href": _vm.link
    }
  }, [_c('img', {
    attrs: {
      "src": _vm.image,
      "alt": _vm.alt
    }
  }), _vm._v(" "), (_vm.message) ? _c('div', {
    staticClass: "section-message"
  }, [_c('a', {
    attrs: {
      "href": _vm.link
    }
  }, [_vm._v(_vm._s(_vm.message))]), _vm._v(" "), _c('div', {
    staticClass: "section-message-child"
  }, [_vm._t("default")], 2)]) : _vm._e()])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5010d0ee"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/article/section-link.vue
// module id = 175
// module chunks = 4